import { defineComponent as _defineComponent } from 'vue'
import { AuthorityType, Beneficiary, beneficiaryName } from 'ah-api-gateways';
import { BModal } from 'bootstrap-vue';
import { makeFormModel } from 'ah-common-lib/src/form/helpers';
import { radioField } from 'ah-common-lib/src/form/models';
import WithdrawFromWallet from 'ah-wallets/src/components/WithdrawFromWallet.vue';
import { computed, reactive, ref, defineAsyncComponent } from 'vue';
import { useAhBeneficiariesState } from '..';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';


export default /*#__PURE__*/_defineComponent({
  __name: 'SendMoneyToBeneficiaryModal',
  props: {
    beneficiary: null
  },
  emits: ["flow-completed"],
  setup(__props: any, { emit }: { emit: ({
  /**
   * - flow-completed: emmited onSuccess
   */
  (e: 'flow-completed'): void;
}), expose: any, slots: any, attrs: any }) {

const TradeCreator = defineAsyncComponent(() => import('ah-trades/src/components/TradeCreator.vue'));



const tradeFlowModal = ref<InstanceType<typeof BModal> | null>(null);



const beneficiariesState = useAhBeneficiariesState();

const canRequestPrices = computed(() => {
  return beneficiariesState.store.useAuthStore().hasAuthorities(AuthorityType.REQUEST_PRICES) || onBehalfOfClient.value;
});

const state = reactive({
  tradeStage: '' as string,
  sendTypeForm: makeFormModel({
    name: 'tradeTypeForm',
    fieldType: 'form',
    fields: [
      radioField(
        'type',
        '',
        [
          {
            label: 'Same Currency',
            value: 'sameCurrency',
          },
          {
            label: 'Currency Exchange',
            value: 'currencyExchange',
            disabled: !canRequestPrices.value,
          },
        ],
        {
          defaultValue: 'sameCurrency',
          inline: true,
          fieldWrapperClass: 'col col-12 mb-n1',
        }
      ),
    ],
  }),
});

const onBehalfOfClient = useOnBehalfOf();

const canExchange = computed(() => {
  return beneficiariesState.store.useAuthStore().isClientUser || onBehalfOfClient.value;
});

function onStageChange(stage: string) {
  state.tradeStage = stage;
}

function show() {
  tradeFlowModal.value!.show();
}

function onCancel() {
  tradeFlowModal.value!.hide();
}

function onSuccess() {
  tradeFlowModal.value!.hide();
  emit('flow-completed');
}

function findBeneficiaryName(beneficiary: Beneficiary) {
  return beneficiaryName(beneficiary);
}

return { __sfc: true,TradeCreator, emit, tradeFlowModal, beneficiariesState, canRequestPrices, state, onBehalfOfClient, canExchange, onStageChange, show, onCancel, onSuccess, findBeneficiaryName, BModal, WithdrawFromWallet }
}

})